import { inject, Injectable } from '@angular/core';

import { HrtApiService } from '@shared/services';
import { SubscriptionReporting } from '@shared/models';

@Injectable({
  providedIn: 'root',
})
export class ReportingApiService {
  readonly api = inject(HrtApiService);

  submit(subscribe: boolean, userRole: string) {
    return this.api.postForOrganization<SubscriptionReporting>(
      `reporting/${subscribe ? 'subscribe' : 'unsubscribe'}?userRole=${userRole}`
    );
  }

  getReporting() {
    return this.api.getForOrganization<SubscriptionReporting>(`reporting/subscription`);
  }
}
